import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { EquipmentSizeViewComponent } from './equipment-size-view/equipment-size-view.component';


const routes: Routes = [
    {
        path: '',
        data: {
            title: 'Equipment Size',
          },
        component: EquipmentSizeViewComponent,
    }
]

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class EquipmentSizeRoutingModule { }